import { ensureString } from './ensureString'
import { RuntimeEnv } from './getRuntimeEnv'
import { isString } from './isString'

const { runtime, buildTMS } = RuntimeEnv

/**
 * checks whether the current runtime environemnt matches one of the given values
 * @param what the requested runtime environments
 * @returns true if the current runtime environment is included in the given environments; false otherwise
 */
export function isRuntimeEnv(...what: Array<'prod' | 'beta' | 'dev'>): boolean {
  try {
    const env = runtime
    if (isString(env)) {
      return what.includes(env as 'prod' | 'beta' | 'dev')
    }
  } catch (error) {
    console.warn(error)
  }
  return false
}

/**
 *  @returns true if we're running in a production environment; false otherwise
 */
export function isProdEnv() {
  return isRuntimeEnv('prod')
}

/**
 *  @returns true if we're running in a development environment; false otherwise
 */
export function isDevEnv() {
  return !isProdEnv()
}

export function getBuildTimestamp(): string {
  try {
    const tms = buildTMS
    return ensureString(tms)
  } catch (error) {
    console.warn(error)
  }
  return ''
}
